<template>
  <div class="align-items-center flex flex-column">
    <div class="flex justify-content-start gap-2 w-full align-items-center">
      <h2 class="primaryTitle pimaryFont" test-id="titleActuacion">
        {{ title }}
      </h2>
      <StateChip :stateText="stateText" :stateColor="stateColor" />
      <StateChip
        v-if="isShared"
        stateText="Compartido"
        :stateColor="{
          backgroundColor: '#3758F9',
          fontColor: '#ffffff',
        }"
      />
    </div>
    <div v-if="loadingSecretary" class="flex justify-start-center gap-4 w-full mt-2 mb-2">
      <Skeleton width="350px" height="20px" borderRadius="16px" />
      <Skeleton width="350px" height="20px" borderRadius="16px" />
    </div>
    <div v-else class="flex justify-start-center gap-4 w-full mt-2 mb-2">
      <div class="flex align-items-center gap-2 justify-content-center">
        <UserRoundCheck style="width: 20px; height: 20px; color: #0b5195" />
        <span class="secretary"
          >Secretario Actual <span class="secretary-value">{{ secretarioActual }}</span></span
        >
      </div>
      <div class="flex align-items-center gap-2 justify-content-center">
        <UserRoundPen style="width: 20px; height: 20px; color: #0b5195" />
        <span class="secretary"
          >Secretario Original <span class="secretary-value">{{ secretarioOriginal }}</span></span
        >
      </div>
      <div class="flex align-items-center gap-2 justify-content-center">
        <Calendar style="width: 20px; height: 20px; color: #0b5195" />
        <span class="secretary"
          >Denuncia en Fecha <span class="secretary-value">{{ fechaDenuncia }}</span></span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, nextTick } from "vue";
import StateChip from "./StateChip.vue";
import { UserRoundCheck, UserRoundPen, Calendar } from "lucide-vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  stateText: {
    type: String,
    required: true,
  },
  stateColor: {
    type: Object,
    required: true,
  },
  isShared: {
    type: Boolean,
    default: false,
  },
  sumario: {
    type: Object,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
});

const loadingSecretary = ref(false);
const dangerClass = ref(false);

const fechaDenuncia = computed(() => {
  const fecha = props.sumario?.fechaDenuncia;
  if (!fecha) return "Fecha desconocida";

  // Convertimos a formato ISO válido
  const formatted = fecha.replace(" ", "T");
  const dateObj = new Date(formatted);

  if (isNaN(dateObj.getTime())) {
    return "Fecha inválida";
  }

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
});

const secretarioOriginal = computed(() => {
  const actuacion = props.sumario?.originalUser;
  let apellido = actuacion?.Apellido || "";
  let nombre = actuacion?.Nombre || "";
  const result = [apellido, nombre].filter(Boolean).join(", ");
  return result || "Nombre desconocido";
});

const secretarioActual = computed(() => {
  const actuacion = props.sumario?.ActuacionUsuarioDependencia;

  if (!actuacion) {
    return `${props.user.userdata.apellido}, ${props.user.userdata.nombre}`;
  }

  const actual = actuacion.find((e) => e.Fechahasta === null);

  if (!actual) {
    dangerClass.value = true;
    return "Los datos de la Persona asociados a este Usuario fueron borrados";
  }

  if (actual.Apellido !== "Persona de Filiacion desconocida") {
    return `${actual.Apellido}, ${actual.Nombre}`;
  } else {
    dangerClass.value = true;
    return "NO está asignado ningun secretario";
  }
});

watch(
  () => props.sumario?.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      loadingSecretary.value = true;
      nextTick(() => {
        loadingSecretary.value = false;
      });
    }
  },
  { immediate: false }
);
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.primaryTitle {
  font-weight: 700;
  font-style: bold;
  font-size: 32px;
  margin: 0;
  color: black;
  font-family: "IBM Plex Sans", sans-serif;
}

.secretary {
  color: #0b5195;
  font-weight: 700;
  font-size: 16px;
  font-family: "IBM Plex Sans", sans-serif;
}

.secretary-value {
  font-weight: 400;
}

@media (max-width: 1080px) and (max-height: 720px) {
  .primaryTitle {
    font-size: 24px;
  }

  .secretary-value {
    font-size: 12px;
  }
}
</style>
